import { DATE_F } from 'common/helpers/formtatters';
import { AntDatePicker } from 'components/ant/AntDatePicker';
import type { Dayjs } from 'dayjs';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import s from './RangePicker.module.less';

interface Props {
  startDate?: Dayjs | null;
  endDate?: Dayjs | null;
  onStartDateChange: (date: Dayjs | null) => void;
  onEndDateChange: (date: Dayjs | null) => void;
}

export const RangePicker: FC<Props> = ({ startDate, endDate, onStartDateChange, onEndDateChange }) => {
  const { t } = useTranslation();
  const disabledEndDate = (current: Dayjs) => {
    return startDate ? startDate.isAfter(current) : false;
  };

  const disabledStartDate = (current: Dayjs) => {
    const endDateToDays = endDate?.startOf('day');
    const currentDateToDays = current.startOf('day');

    return endDateToDays ? endDateToDays?.isBefore(currentDateToDays) : false;
  };

  return (
    <div className={s.container}>
      <div className={s.datePickerCnt}>
        <div className={s.label}>{t('calendar.startDate')}</div>
        <AntDatePicker
          name="startDate"
          format={DATE_F}
          value={startDate}
          onChange={(value) => onStartDateChange(value)}
          disabledDate={disabledStartDate}
          getPopupContainer={(trigger: HTMLElement) => trigger.parentElement as HTMLElement}
        />
      </div>
      <span className={s.separator}>&mdash;</span>
      <div className={s.datePickerCnt}>
        <div className={s.label}>{t('calendar.endDate')}</div>
        <AntDatePicker
          name="endDate"
          format={DATE_F}
          value={endDate}
          onChange={(value) => onEndDateChange(value)}
          disabledDate={disabledEndDate}
          getPopupContainer={(trigger: HTMLElement) => trigger.parentElement as HTMLElement}
        />
      </div>
    </div>
  );
};
